import {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS,
  DEPARTURE_UNLOCODE_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_DEPARTURE_UNLOCODES,
  DESELECT_ALL_DEPARTURE_UNLOCODES,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_UNLOCODE_ADMIN,
} from './types/DeparturePostalOperatorActionTypes';

export function retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator(
  payload,
  reportDefinition,
  departureCheckedUnlocodes,
) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST,
    payload,
    reportDefinition,
    departureCheckedUnlocodes,
  };
}

export function retrieveOutboundPostalOperatorsUnlocodeSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS,
    payload,
  };
}

export function retrieveOutboundPostalOperatorsUnlocodeFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE,
    error,
  };
}

export function departureUnlocodeCheckedActionCreator(
  checkedUnlocodes,
  reportDefinition,
) {
  return {
    type: DEPARTURE_UNLOCODE_CHECKED,
    checkedUnlocodes,
    reportDefinition,
  };
}

export function onDeparturePostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onDeparturePostalOperatorExpandedUnlocodeAdmin(expandedPostalOperatorsUnlocodeAdmin) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED_UNLOCODE_ADMIN,
    expandedPostalOperatorsUnlocodeAdmin,
  };
}

export function onSelectAllDepartureUnlocodes(nodes) {
  return {
    type: SELECT_ALL_DEPARTURE_UNLOCODES,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllDepartureUnlocodes() {
  return {
    type: DESELECT_ALL_DEPARTURE_UNLOCODES,
  };
}
